import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        defaultFilter: '='
    },
    template: `
        <div class="table-filters">
                <form ng-submit="vm.applyFilter()" class="form form-filter">
                    <div class="fields">
                        <div class="row">
                            <label class="label">{{ 'integrationLog.From' | translate }}</label>
                            <div class="items">
                                <datepicker-api ng-model="vm.filter.from"></datepicker-api>
                            </div>
                        </div>
                        <div class="row">
                            <label class="label">{{ 'integrationLog.To' | translate }}</label>
                            <div class="items">
                                <datepicker-api ng-model="vm.filter.to"></datepicker-api>
                            </div>
                        </div>
                        <div class="row">
                            <label class="label">{{ 'integrationLog.Keyword' | translate }}</label>
                            <div class="items">
                                <input type="text" class="form-control" ng-model="vm.filter.keyword">
                            </div>
                        </div>
                        <div class="row">
                            <label class="label">{{ 'integrationLog.Integration type' | translate }}</label>
                            <div class="items">
                                <div
                                    ng-dropdown-multiselect=""
                                    options="vm.multiFilter.types.options"
                                    selected-model="vm.multiFilter.types.model"
                                    extra-settings="vm.multiFilter.types.settings"
                                    translation-texts="vm.filterTranslations"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul class="actions01">
                        <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                        <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                    </ul>
                </form>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, FilterService, INTEGRATIONLOG_TYPE_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.FilterService = FilterService;
        this.INTEGRATIONLOG_TYPE_ENUM = INTEGRATIONLOG_TYPE_ENUM;
    }

    $onInit () {
        this.filter = angular.copy(this.defaultFilter);
        this.filterTranslations = this.FilterService.getTranslations();
        this.initMultiFilter();
    }

    initMultiFilter () {
        const typeOptions = [
            { value: this.INTEGRATIONLOG_TYPE_ENUM.KEYS.USER_IMPORT, label: this.INTEGRATIONLOG_TYPE_ENUM.LABELS.USER_IMPORT },
            { value: this.INTEGRATIONLOG_TYPE_ENUM.KEYS.STRUCTURE_IMPORT, label: this.INTEGRATIONLOG_TYPE_ENUM.LABELS.STRUCTURE_IMPORT },
            { value: this.INTEGRATIONLOG_TYPE_ENUM.KEYS.INACTIVITY_IMPORT, label: this.INTEGRATIONLOG_TYPE_ENUM.LABELS.INACTIVITY_IMPORT },
            { value: this.INTEGRATIONLOG_TYPE_ENUM.KEYS.WP_SYNC, label: this.INTEGRATIONLOG_TYPE_ENUM.LABELS.WP_SYNC }
        ];

        this.multiFilter = {
            types: {
                model: [],
                options: typeOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    applyFilter () {
        this.filter = this.lodash.assign(this.filter, { 'type[]': this.multiFilter.types.model.map(type => type.value) });
        this.list.fetch(this.filter);
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/logs/integrationlog/filter/index.js